import AlertDialog from './AlertBox';

export default AlertDialog;
